import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((config) => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Public
export const submitLead = (data) => apiClient.post("/leads", data).then((r) => r.data);

// Admin auth
export const adminLogin = (data) => apiClient.post("/admin/login", data).then((r) => r.data);
export const adminMe = () => apiClient.get("/admin/me").then((r) => r.data);

// Leads
export const fetchLeads = (search = "") =>
    apiClient.get("/admin/leads", { params: search ? { search } : {} }).then((r) => r.data);
export const fetchStats = () => apiClient.get("/admin/stats").then((r) => r.data);
export const fetchSenderInfo = () => apiClient.get("/admin/sender-info").then((r) => r.data);
export const resendWelcome = (leadId) =>
    apiClient.post(`/admin/leads/${leadId}/resend-welcome`).then((r) => r.data);

export const exportLeadsCSV = async () => {
    const res = await apiClient.get("/admin/leads/export", { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.download = `leads_export_${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

// Analytics
export const fetchAnalytics = () => apiClient.get("/admin/analytics").then((r) => r.data);
export const enrichLocations = () =>
    apiClient.post("/admin/leads/enrich-locations").then((r) => r.data);

// Welcome Email template
export const fetchWelcomeTemplate = () =>
    apiClient.get("/admin/welcome-email").then((r) => r.data);
export const saveWelcomeTemplate = (data) =>
    apiClient.put("/admin/welcome-email", data).then((r) => r.data);
export const resetWelcomeTemplate = () =>
    apiClient.post("/admin/welcome-email/reset").then((r) => r.data);
export const previewWelcomeTemplate = (data) =>
    apiClient.post("/admin/welcome-email/preview", data).then((r) => r.data);
export const sendTestWelcomeTemplate = (data) =>
    apiClient.post("/admin/welcome-email/test", data).then((r) => r.data);

// Success Page content
export const fetchPublicSuccessPage = () =>
    apiClient.get("/success-page").then((r) => r.data);
export const fetchAdminSuccessPage = () =>
    apiClient.get("/admin/success-page").then((r) => r.data);
export const saveSuccessPage = (data) =>
    apiClient.put("/admin/success-page", data).then((r) => r.data);
export const resetSuccessPage = () =>
    apiClient.post("/admin/success-page/reset").then((r) => r.data);

// Campaigns
export const fetchCampaigns = () => apiClient.get("/admin/campaigns").then((r) => r.data);
export const fetchCampaign = (id) => apiClient.get(`/admin/campaigns/${id}`).then((r) => r.data);
export const fetchCampaignRecipients = (id) =>
    apiClient.get(`/admin/campaigns/${id}/recipients`).then((r) => r.data);
export const createCampaign = (data) =>
    apiClient.post("/admin/campaigns", data).then((r) => r.data);
export const cancelCampaign = (id) =>
    apiClient.delete(`/admin/campaigns/${id}`).then((r) => r.data);
export const previewCampaignRecipients = (data) =>
    apiClient.post("/admin/campaigns/preview", data).then((r) => r.data);
export const renderCampaignPreview = (data) =>
    apiClient.post("/admin/campaigns/render", data).then((r) => r.data);
